export enum ExternalURLs {
  LinkedInPage = 'https://www.linkedin.com/company/the-xp-lab/',
  DiscordInvite = 'https://discord.gg/aWTWHDqQW4',
  DiscordInviteIntoBugReportChannel = 'https://discord.gg/UD66A5Mn',
}